import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import StaffSelector from '@cloudpivot/form/src/renderer/components/shared/staff-selector.vue';
let SelectUser = class SelectUser extends Vue {
    constructor() {
        super(...arguments);
        this.selectorData = [];
        this.taffSelectorOpts = {
            selectOrg: true,
            selectUser: true,
            showModel: false,
            mulpitle: true,
            showSelect: false,
            placeholder: '请选择'
        };
    }
    get corpId() {
        try {
            let user = sessionStorage.getItem('user');
            user = JSON.parse(user);
            if (user.corpId) {
                return user.corpId;
            }
            else {
                return '';
            }
        }
        catch (_a) {
            return '';
        }
    }
    /*
    * 打开选人控件
    */
    setUser(selector) {
        if (this.batch) {
            //批量修改时判断是否有选择数据
            let resouce = this.value.find((v) => v.checked);
            if (!resouce) {
                this.$message.error(this.$t('cloudpivot.list.pc.chooseData'));
                return;
            }
            //判断是否选择子表数据
            if (this.isSheet) {
                let sheetArr = [];
                this.value.forEach((v) => {
                    if (v.checked) {
                        sheetArr = sheetArr.concat(v[this.sheetKey]);
                    }
                });
                let sheetResouce = sheetArr.find((s) => s.checked);
                if (!sheetResouce) {
                    this.$message.error(this.$t('cloudpivot.list.pc.chooseSheetData'));
                    return;
                }
            }
        }
        if (this.row.key === 'owner') {
            this.taffSelectorOpts = {
                selectOrg: false,
                selectUser: true,
                showModel: false,
                mulpitle: false,
                showSelect: false,
                placeholder: '请选择'
            };
        }
        this.taffSelectorOpts.showModel = true;
    }
    /*
    * 选人控件确定事件
    */
    submitUser(val) {
        const value = val.map((v) => {
            return {
                excelType: v.excelType,
                id: v.id,
                type: v.type,
                name: v.name,
                imgUrl: v.imgUrl,
                departmentId: null,
                departments: null,
                parentId: null,
            };
        });
        if (this.batch) {
            const resouce = this.value.forEach((v) => {
                if (v.checked) {
                    if (this.isSheet) {
                        v[this.sheetKey].forEach((s) => {
                            if (s.checked) {
                                s[this.row.key] = value;
                            }
                        });
                    }
                    else {
                        v[this.row.key] = value;
                    }
                }
            });
            this.$emit('input', resouce);
        }
        else {
            this.$emit('input', value);
        }
        this.taffSelectorOpts.showModel = false;
    }
    /*
    * 选人控件取消事件
    */
    cancel() {
        this.taffSelectorOpts.showModel = false;
    }
    onUserDataChange(value) {
        if (this.batch) {
            this.selectorData = [];
        }
        else {
            // 必填且返回为空的值，不写入选人控件
            if (value && value[0] && value[0].excelType === 3) {
                this.selectorData = [];
                return;
            }
            this.selectorData = value;
        }
    }
};
tslib_1.__decorate([
    Prop()
], SelectUser.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], SelectUser.prototype, "row", void 0);
tslib_1.__decorate([
    Prop()
], SelectUser.prototype, "sheetKey", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], SelectUser.prototype, "batch", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], SelectUser.prototype, "isSheet", void 0);
tslib_1.__decorate([
    Watch('value', { deep: true, immediate: true })
], SelectUser.prototype, "onUserDataChange", null);
SelectUser = tslib_1.__decorate([
    Component({
        name: "select-user",
        components: {
            StaffSelector
        }
    })
], SelectUser);
export default SelectUser;
